/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var quantitySelectorValue = '';

document.addEventListener('variant:changed', function(event) {
  var currentLengthWrapper = document.querySelector('.CurrentLength__Wrapper');
  if (currentLengthWrapper && event.detail.variant) {
  	currentLengthWrapper.style.visibility = event.detail.variant.title.includes('continuous') ? 'visible' : 'hidden';
  }
});

document.addEventListener('load', function(event) {
  quantitySelectorValue = '';
});

setInterval(updateQuantitySelectorCurrentLength, 100);
setInterval(updateThreadPickButton, 100);
setInterval(updateFabricQuantitySelectorCurrentLength, 100);


function updateQuantitySelectorCurrentLength() {
  var quantitySelector = document.querySelector('.ProductForm__QuantitySelector .QuantitySelector__CurrentQuantity');
  if (quantitySelector) {
    var newValue = quantitySelector.value;
    if (newValue !== quantitySelectorValue) {
      quantitySelectorValue = newValue;
      currentLengthElement = document.querySelector('.ProductForm__QuantitySelector .QuantitySelector__CurrentLength');
      if (currentLengthElement) {
        currentLengthElement.value = (Math.max(parseInt(quantitySelectorValue) || 1, 1) * 0.1).toFixed(1) + 'm';
      }
    }
  }
}

function updateFabricQuantitySelectorCurrentLength() {
  var quantitySelector = document.getElementById('quantityDisplay');
  if (quantitySelector) {   
    var newValue = quantitySelector.value.replace('m','');
    document.getElementById('productAddbtn').dataset.qty = newValue * 10;
    document.getElementById('calculatedLength').innerHTML = newValue + " metres";
    let price = document.getElementById('quantityDisplay').dataset.variantprice * 1;
    let newPrice = price * newValue * 10;
    newPrice = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(newPrice / 100);
    document.getElementById('theadTotal').innerHTML = newPrice;
  }
}

// function updateQuantitySelectorCurrentLength() {
//   var quantitySelector = document.querySelector('.ProductForm__QuantitySelector .QuantitySelector__CurrentQuantity');
//   if (quantitySelector) {
//     var newValue = quantitySelector.value * 1;

//     var minQuantity = 0

//     if(quantitySelector.value == ''){
//       return false;
//     }

//     if(quantitySelector != null){
//       minQuantity = quantitySelector.dataset.minquantity;
//       if(minQuantity == null){
//         return false;
//       }
//       if(newValue <= minQuantity){
//         newValue = minQuantity;
//         quantitySelectorValue.value = newValue;
//         quantitySelector.value = minQuantity;
//         disableMinPicker();
//       } else {
//         enableMinPicker();
//       }
//     }  

//     if (newValue !== quantitySelectorValue) {
//       quantitySelectorValue = newValue;
//       currentLengthElement = document.querySelector('.ProductForm__QuantitySelector .QuantitySelector__CurrentLength');
//       if (currentLengthElement) {
//         currentLengthElement.value = (Math.max(parseInt(quantitySelectorValue) || 1, 1) * 0.1).toFixed(1) + 'm';
//       }
//     }
//   }
// }

function disableMinPicker(){
  var minBtn = document.getElementById('minBtn');
  minBtn.dataset.action = "decrease-quantity-disabled"
}

function enableMinPicker(){
  var minBtn = document.getElementById('minBtn');
  minBtn.dataset.action = "decrease-quantity"
}

function updateThreadPickButton(){
  let threadQuantity = document.getElementById('threadQuantity');
  if(threadQuantity != null){

    let addToCartBtn = document.getElementById('threadAddBtn');
    if(threadQuantity.value != addToCartBtn.dataset.qty){
      addToCartBtn.dataset.qty = threadQuantity.value;
      let price =  addToCartBtn.dataset.price * 1;
      let total = price * (addToCartBtn.dataset.qty * 1);
      
      let newPrice = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(total / 100);
      document.getElementById('threadTotal').innerHTML = newPrice;  


      // if(document.getElementById('threadTotal') != null){
      //   document.getElementById('threadTotal').innerHTML = 'Add To Cart  •  ' + formatter.format(total / 100);
      // }
      
    }
  }
}

var ajaxButtons = document.getElementsByClassName('ajaxCartAdd');

for(let i = 0; i < ajaxButtons.length; i++) {
  ajaxButtons[i].addEventListener("click", function(event) {
    event.preventDefault();
    let qty = ajaxButtons[i].dataset.qty;
    let variantId = ajaxButtons[i].dataset.variantid;
    let isFabric = 0;
    let isSample = 0;
    let isThread = 0;
    
    if(ajaxButtons[i].dataset.issample != null){
      isSample = ajaxButtons[i].dataset.issample;
    }
    if(ajaxButtons[i].dataset.isfabric != null){
      isFabric = ajaxButtons[i].dataset.isfabric;
    }
    if(ajaxButtons[i].dataset.isthread != null){
      isThread = ajaxButtons[i].dataset.isthread;
    }

    let _data = {
      id: variantId,
      quantity: qty, 
      // properties: {
      //   '_isSample' : isSample,
      //   '_isFabric' : isFabric,
      //   '_isThread' : isThread,
      // }
    };
//     if(isFabric == 1){
//       _data.properties._uniqueId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
//     }
    
    addAjax(_data);
  })
}

async function getCart(){
  const response = await fetch('/cart.js')
  .then(response => response.json())
  return response;
}

async function addAjax(data){
  const response = await fetch('/cart/add.js', {
    method: "POST",
    body: JSON.stringify(data),
    headers: {"Content-type": "application/json; charset=UTF-8"}
  })
  .then(response => response.json()) 
  .then(json => console.log(json))
  .catch(err => console.log(err));
  updateCartIcon();
  pageSync();
}

function updateCartIcon(){
  document.getElementById('cartIcon').classList.add("animate__animated","animate__bounce");
  var y = document.getElementsByClassName('Header__CartDot');
  y[0].classList.add('is-visible');
  
  setTimeout(function() {
    document.getElementById('cartIcon').classList.remove("animate__animated","animate__bounce")
  }, 750);
}


function fabricMinBtnClicked(element){
  let elem = document.getElementById('quantityDisplay');
  let existingValue = elem.value.replace("m",'') * 1;
  if(existingValue > 0.5){
    let newVal = changeQuantity(elem, 0.1,'down');
    elem.value = newVal + "m";

    let price = document.getElementById('quantityDisplay').dataset.variantprice * 1;
    let newPrice = price * newVal * 10;
    newPrice = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(newPrice / 100);
    document.getElementById('theadTotal').innerHTML = newPrice;
  }
}

function fabricMaxBtnClicked(element){
  let elem = document.getElementById('quantityDisplay');
  let existingValue = elem.value.replace("m",'') * 1;
  let newVal = changeQuantity(elem, 0.1,'up');
  elem.value = newVal + "m"; 

  let price = document.getElementById('quantityDisplay').dataset.variantprice * 1;
  let newPrice = price * newVal * 10;
  newPrice = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(newPrice / 100);
  document.getElementById('theadTotal').innerHTML = newPrice;
  // document.getElementById('productAddbtn').dataset.qty = newVal;
}

function minCartBtnClick(element){
  let elem = element.nextElementSibling;
  let originalVal = elem.value;
  let newVal = changeQuantity(elem, 0.1,'down');
  elem.value = newVal + "m";
  let status = updateCartOnBlur(elem, 'btn');
  if(status == false){
    elem.value = originalVal;
    // document.getElementById('productAddbtn').dataset.qty = originalVal.replace("m",'');
  }
}

function maxCartBtnClick(element){
  let elem = element.previousElementSibling;
  let originalVal = elem.value;
  let newVal = changeQuantity(elem, 0.1,'up');
  elem.value = newVal + "m";
  if(newVal >= 0.5){
    let status = updateCartOnBlur(elem, 'btn');
    if(status == false){
      elem.value = originalVal;
    }
  }
}

function changeQuantity(target, steps, direction){
  let currentValue = target.value.replace('m','') * 1;
  let newValue = currentValue;
  let minQuantity = 1;
  if(target.dataset.minquantity != null){
    minQuantity = target.dataset.minquantity * 1;
  }
  if(direction == "up"){
    newValue += steps;
  } else if(direction == "down"){
    newValue -= steps;
    if(newValue < minQuantity){
      newValue = minQuantity;
    }
  }
  return Math.round(newValue * 10) / 10;
  // target.value = Math.round(newValue * 10) / 10 + 'm';
}

async function pageSync(){
  let cartContents = await getCart();
  let items = cartContents.items;
  // Update balance meters in product page and check if sample is added
  console.log(items);
  productVariants.forEach(function(variant){
    let balance = variant.availableQty * 1;
    items.forEach(function(item, index){
      if(variant.variantId == item.variant_id){
        if(variant.isSample == true){
          //Sample already in cart. Disable button
          document.getElementById('sampleBtn').disabled = true;
          document.getElementById('sampleBtn').innerHTML = "Sample in cart";
          document.getElementById('sampleBtn').classList.remove('Button--primary');
        }
        if(variant.isFabric == true){
          balance -= (item.quantity * 1);
          document.getElementById('balanceFabricLength').innerHTML = Math.round((balance/10) * 10) / 10;
        }
      }
    });
  });
}


async function checkPhysicalCard(element, price, qty, lineItemId){
  if(element.checked == true){
    let _data = {
      id: '37969283481789',
      quantity: qty, 
      properties: {
        '_isSample' : false,
        '_isFabric' : false,
        '_isThread' : false,
        '_isGiftCard': true,
        'Gift Card Price' : price,
        '_parentId' : lineItemId
      }
    };
    let response = await addAjax(_data);
    location.reload();
  }
}


if(document.getElementById('quantityDisplay') != null){
  document.getElementById('quantityDisplay').addEventListener('blur',function(){
    let qty = document.getElementById('quantityDisplay').value.replace('m','') * 1;
    if(qty < 0.5){
      document.getElementById('quantityDisplay').value = "0.5m";
    }
  });
}

function updateCartOnBlur(target,trigger = 'txt'){
  if(target.dataset.original == target.value){
    return false;
  }
  let qty = target.value.replace('m','')  * 1;
  if(target.dataset.isfabric != null && qty < 0.5 && trigger == 'txt'){
    // let lineId = target.getAttribute('data-line-id');   
    // console.log('minQtyWarning_' + lineId);
    // console.log(document.getElementById('minQtyWarning_' + lineId).innerHTML);
    // document.getElementById('minQtyWarning_' + lineId).classList.remove('isHidden');
    // alert('Minimum allowed quantity is 5 (0.5m)');

    let warning = target.parentElement.parentElement.parentElement.nextElementSibling;
    warning.style.display = 'block';

    target.classList.add("animate__animated","animate__shakeX");
    setTimeout(function() {
      target.classList.remove("animate__animated","animate__shakeX")
    }, 750);
    return false;
  }
  qty = qty * 10;
  
  let tr = document.querySelector('.PageTransition');
  tr.style.opacity = '1';
  
  fetch(window.theme.localeRootUrl + '/cart/change.js', {
    body: JSON.stringify({ id: target.getAttribute('data-line-id'), quantity: qty }),
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
    }
  }).then(function (cart) {
    location.reload();
  });
}

async function removePhysicalCardOption(){
  let cartContents = await getCart();
  let items = cartContents.items;
  // Update balance meters in product page and check if sample is added
  //Hide "Phycial Gift Cart" checkbox in cart if gift card is already added
  items.forEach(function(item, index){
    if(item.properties._parentId != null){
      document.getElementById('cb_' + item.properties._parentId ).innerHTML = "<span class='noticeBadge'>Physical Gift Card Added</span>";
    }
  });
}

// setInterval(removePhysicalCardOption, 100);

pageSync();